import {useEffect, useRef} from 'react'
import type {RefObject, ComponentPropsWithoutRef, PropsWithChildren} from 'react'

function useObservedElement<T extends Element>(
  elementRef: RefObject<T | null>,
  observe?: (element: Element) => void,
  unobserve?: (element: Element) => void,
) {
  useEffect(() => {
    if (elementRef.current) {
      const ref = elementRef.current
      observe?.(ref)
      return () => unobserve?.(ref)
    }
  }, [elementRef, observe, unobserve])
}

export interface ObservableBoxProps extends PropsWithChildren<ComponentPropsWithoutRef<'div'>> {
  onObserve?: (element: Element) => void
  onUnobserve?: (element: Element) => void
}

export function ObservableBox({children, onObserve, onUnobserve, className, ...props}: ObservableBoxProps) {
  const boxRef = useRef<HTMLDivElement>(null)
  useObservedElement(boxRef, onObserve, onUnobserve)
  return (
    <div className={className} {...props} ref={boxRef}>
      {children}
    </div>
  )
}
